/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_TitleInputs */

const en_minifier_title = /** @type {(inputs: Minifier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online JSON Minifier`)
};

const ko_minifier_title = /** @type {(inputs: Minifier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`온라인 JSON 압축기`)
};

const ja_minifier_title = /** @type {(inputs: Minifier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインJSON圧縮ツール`)
};

/**
* | output |
* | --- |
* | "Online JSON Minifier" |
*
* @param {Minifier_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_title = /** @type {((inputs?: Minifier_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_title(inputs)
	if (locale === "ko") return ko_minifier_title(inputs)
	return ja_minifier_title(inputs)
});